import "./NumberInput.css";

export default function NumberInput({
  placeholder = "A Number Input",
  minValue = 0,
  maxValue = 220,
  id,
  onChange,
  errorMode,
  value = "",
  disabled = false
}) {

  return (
    <input
      disabled={disabled}
      className={
        errorMode ? "numberInput-error-container" : "numberInput-container"
      }
      type="number"
      inputMode="numeric"
      onChange={(event) => {
        onChange(event.target.value);
      }}
      placeholder={placeholder}
      id={id}
      value={value}
    />
  );
}
